/* eslint-disable camelcase */
import { FeedbackMap } from 'components/feedback/hooks/types';
import React, { useState } from 'react';
import styled from 'styled-components';
import { MessageList } from './MessageList';

const Wrapper = styled.div<{ empty: boolean }>`
  height: 100%;
  padding: 0 var(--spacing-4);
`;

export interface MessageThreadProps {
  subscriber: any;
  isChatLoading?: boolean;
  messageThreadRef: React.RefObject<HTMLUListElement>;
  feedback_items?: any;
  itFeedbackItems?: FeedbackMap;
}

const MessageThread = ({
  subscriber,
  isChatLoading,
  messageThreadRef,
  feedback_items,
  itFeedbackItems,
}: MessageThreadProps): JSX.Element => {
  const [isEmpty, setIsEmpty] = useState(false);

  if (isChatLoading) {
    // For Responses, return empty div
    // to fill out the parent grid area
    return <div />;
  }

  return (
    <Wrapper empty={isEmpty}>
      <MessageList
        messageThreadRef={messageThreadRef}
        subscriber={subscriber}
        feedback_items={feedback_items}
        itFeedbackItems={itFeedbackItems}
        onEmptyStateChange={setIsEmpty}
      />
    </Wrapper>
  );
};

export default React.memo(MessageThread);
